import axios from 'axios'

export default {
    async fetchAll() {
        return await axios.get(`itemtype`)
    },

    async create(model) {
        return await axios.post(`itemtype`, model)
    },
    async fetchById(id) {
        return await axios.get(`itemtype/${id}`)
    },

    async update(id, model) {
        return await axios.put(`itemtype/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`itemtype/${id}`)
    },
    async uploadOrderTypes(payload){
        return await axios.post(`itemtype/upload`, payload)
       
    }
}
